module.exports = __webpack_public_path__ + "static/media/2019-03-14-01.6339bb61.jpg";